/* Smart Basics Paws — product.js
   Buy box: bundle tiers, formula picker, variant picker, pay-later calculator, gallery,
   AJAX add to cart (single-flight, never adds twice) and the sticky mobile Add to cart. */
(function () {
  'use strict';
  if (window.SBPBuyBoxLoaded) return;
  window.SBPBuyBoxLoaded = true;

  var SBP = window.SBP || {};
  var strings = SBP.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return SBP.formatMoney ? SBP.formatMoney(c) : 'R ' + (c / 100).toFixed(2); };
  var clamp = function (n, a, b) { return Math.min(b, Math.max(a, n)); };

  /* ================================================================ Pay-later calculator */
  function Bnpl(root) {
    this.root = root;
    this.cfg = SBP.bnpl || {};
    this.total = 0;
    this.tabs = $$('[data-bnpl-tab]', root);
    this.panels = {};
    var self = this;
    $$('[data-bnpl-panel]', root).forEach(function (p) { self.panels[p.getAttribute('data-bnpl-panel')] = p; });
    this.sel = {
      stitch: parseInt((this.cfg.stitch || {}).initial, 10) || 3,
      mobicred: parseInt((this.cfg.mobicred || {}).initial, 10) || 12
    };
    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { self.show(tab.getAttribute('data-bnpl-tab')); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = self.tabs[(i + dir + self.tabs.length) % self.tabs.length];
        self.show(next.getAttribute('data-bnpl-tab'), true);
      });
    });
    this.buildChips();
    var first = this.tabs.filter(function (t) { return t.getAttribute('data-bnpl-tab') === self.cfg.first; })[0] || this.tabs[0];
    if (first) this.show(first.getAttribute('data-bnpl-tab'));
  }
  Bnpl.prototype.list = function (str, fallback) {
    var seen = {};
    var arr = String(str || '').split(/[\s,;]+/).map(function (n) { return parseInt(n, 10); })
      .filter(function (n) { if (!(n > 0 && n <= 60) || seen[n]) return false; seen[n] = true; return true; });
    return arr.length ? arr : fallback;
  };
  Bnpl.prototype.buildChips = function () {
    var self = this;
    if (this.panels.stitch) {
      var so = this.list((this.cfg.stitch || {}).options, [2, 3, 4, 6]);
      if (so.indexOf(this.sel.stitch) === -1) this.sel.stitch = so.indexOf(3) > -1 ? 3 : so[0];
      this.chips(this.panels.stitch, so, 'stitch', function (n) { return n + ' payments'; });
    }
    if (this.panels.mobicred) {
      var mo = this.list((this.cfg.mobicred || {}).terms, [3, 6, 12]);
      if (mo.indexOf(this.sel.mobicred) === -1) this.sel.mobicred = mo[mo.length - 1];
      this.chips(this.panels.mobicred, mo, 'mobicred', function (n) { return n + ' months'; });
    }
  };
  Bnpl.prototype.chips = function (panel, opts, key, label) {
    var self = this;
    var wrap = $('[data-bnpl-options]', panel);
    if (!wrap) return;
    wrap.innerHTML = '';
    opts.forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bnpl__chip';
      b.textContent = label(n);
      b.setAttribute('aria-pressed', n === self.sel[key] ? 'true' : 'false');
      b.addEventListener('click', function () {
        self.sel[key] = n;
        $$('.bnpl__chip', wrap).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        self.update(self.total);
      });
      wrap.appendChild(b);
    });
  };
  Bnpl.prototype.show = function (key, focus) {
    var self = this;
    this.tabs.forEach(function (t) {
      var on = t.getAttribute('data-bnpl-tab') === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    Object.keys(this.panels).forEach(function (k) { self.panels[k].hidden = k !== key; });
  };
  /* Split cents into n payments. firstPct > 0: first payment is that %, the rest equal.
     Rounding remainder always lands on the LAST payment, so headline amounts are exact. */
  Bnpl.prototype.split = function (total, n, firstPct) {
    var parts = [];
    if (firstPct > 0 && n > 1) {
      var first = Math.round(total * firstPct / 100);
      var rest = total - first;
      var each = Math.floor(rest / (n - 1));
      parts.push(first);
      for (var i = 1; i < n; i++) parts.push(each);
      parts[n - 1] += rest - each * (n - 1);
    } else {
      var eq = Math.floor(total / n);
      for (var j = 0; j < n; j++) parts.push(eq);
      parts[n - 1] += total - eq * n;
    }
    return parts;
  };
  Bnpl.prototype.update = function (total) {
    this.total = total;
    var c = this.cfg;
    var mt = this.panels.moretyme;
    if (mt) {
      var mc = c.moretyme || {};
      var n = clamp(parseInt(mc.payments, 10) || 3, 2, 6);
      var fp = clamp(parseInt(mc.firstPercent, 10) || 0, 0, 90);
      var days = parseInt(mc.interval, 10) || 30;
      var parts = this.split(total, n, fp);
      $('[data-bnpl-headline]', mt).innerHTML = fp > 0
        ? 'Pay <strong>' + money(parts[0]) + '</strong> today, then ' + (n - 1) + ' × <strong>' + money(parts[1]) + '</strong>'
        : n + ' interest-free payments of <strong>' + money(parts[0]) + '</strong>';
      $('[data-bnpl-schedule]', mt).innerHTML = parts.map(function (p, i) {
        return '<li><b>' + money(p) + '</b><small>' + (i === 0 ? 'Today' : 'In ' + i * days + ' days') + '</small></li>';
      }).join('');
    }
    var st = this.panels.stitch;
    if (st) {
      var k = this.sel.stitch;
      var sp = this.split(total, k, 0);
      $('[data-bnpl-headline]', st).innerHTML = k + ' interest-free instalments of <strong>' + money(sp[0]) + '</strong>';
    }
    var mb = this.panels.mobicred;
    if (mb) {
      var mcfg = c.mobicred || {};
      var m = this.sel.mobicred;
      var rate = parseFloat(String(mcfg.rate || '0').replace(',', '.')) || 0;
      var r = rate / 100 / 12;
      var pmt = r > 0 ? total * r / (1 - Math.pow(1 + r, -m)) : total / m;
      pmt = Math.round(pmt) + (parseInt(mcfg.feeCents, 10) || 0);
      $('[data-bnpl-headline]', mb).innerHTML = 'About <strong>' + money(pmt) + '</strong> a month over ' + m + ' months';
      var note = $('[data-bnpl-note]', mb);
      if (note) note.textContent = String(mcfg.note || '').replace(/\[rate\]/g, rate).replace(/\[months\]/g, m);
    }
  };

  /* ================================================================ Gallery */
  function Gallery(root) {
    this.root = root;
    this.slides = [];
    if (!root) return;
    var self = this;
    this.track = $('[data-gallery-track]', root);
    this.slides = $$('.gallery__slide', root);
    this.thumbs = $$('[data-thumb]', root);
    this.index = 0;
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
    if (this.slides.length < 2) {
      [prev, next].forEach(function (b) { if (b) b.hidden = true; });
    }
    var raf;
    this.target = null;
    this.track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = self.track.clientWidth || 1;
        var i = Math.round(self.track.scrollLeft / w);
        /* while a thumbnail/variant change is smooth-scrolling, don't let the in-between positions
           flick the active thumbnail back and forth */
        if (self.target != null) { if (i === self.target) self.target = null; return; }
        if (i !== self.index) { self.index = i; self.mark(); }
      });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      self.track.addEventListener(ev, function () { self.target = null; }, { passive: true });
    });
  }
  Gallery.prototype.go = function (i) {
    if (!this.slides.length) return;
    i = (i + this.slides.length) % this.slides.length;
    var self = this;
    this.index = i;
    this.target = i;
    clearTimeout(this._settle);
    this._settle = setTimeout(function () { self.target = null; }, 1200);
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    this.mark();
  };
  Gallery.prototype.mark = function () {
    var self = this;
    this.thumbs.forEach(function (t, j) {
      var on = j === self.index;
      t.classList.toggle('is-active', on);
      if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
    });
  };
  Gallery.prototype.find = function (attr, value) {
    if (value == null) return -1;
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].getAttribute(attr) === String(value)) return i;
    }
    return -1;
  };

  /* ================================================================ Buy box */
  function BuyBox(root) {
    this.root = root;
    var cfgEl = $('[data-buybox-config]', root);
    if (!cfgEl) return;
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('Buy box config error', e); return; }
    var cfg = this.cfg;
    cfg.tiers = cfg.tiers || [];
    cfg.variants = cfg.variants || [];
    cfg.formulas = cfg.formulas || [];
    cfg.refill = cfg.refill || [];

    this.form = $('[data-buybox-form]', root);
    this.variantInput = $('[data-variant-input]', root);
    this.formulasInput = $('[data-formulas-input]', root);
    this.qtyInput = $('[data-qty-input]', root);
    this.atc = $('[data-atc]', root);
    this.atcLabel = $('[data-atc-label]', root);
    this.atcPrice = $('[data-atc-price]', root);
    this.buyNow = $('[data-buy-now]', root);
    this.errorEl = $('[data-buybox-error]', root);
    this.freeEl = $('[data-freeship-note]', root);
    this.priceEl = $('[data-price]', root);
    this.compareEl = $('[data-compare]', root);
    this.saveEl = $('[data-save]', root);
    this.tierEls = $$('[data-tier]', root);
    this.picker = $('[data-formula-picker]', root);
    this.chips = $$('[data-formula]', root);
    this.sticky = $('[data-sticky-atc]', root);
    this.busy = false;
    this.preferred = null;

    var bnplEl = $('[data-bnpl]', root);
    this.bnpl = bnplEl ? new Bnpl(bnplEl) : null;
    this.gallery = new Gallery($('[data-gallery]', root));

    var start = clamp(parseInt(cfg.selectedTier, 10) || 0, 0, Math.max(0, cfg.tiers.length - 1));
    if (cfg.tiers[start] && !cfg.tiers[start].available && !cfg.demo) {
      for (var i = 0; i < cfg.tiers.length; i++) { if (cfg.tiers[i].available) { start = i; break; } }
    }
    this.state = { tier: start, single: 'scrubber', picks: [], qty: 1 };

    this.readUrl();
    this.syncPicks();
    this.bind();
    this.initSticky();
    this.render();
    if (this.urlTier != null || this.preferred) this.syncGallery();
  }

  BuyBox.prototype.tier = function () { return this.cfg.useTiers ? this.cfg.tiers[this.state.tier] : null; };

  BuyBox.prototype.formulaIndexFromHandle = function (h) {
    if (!h) return null;
    h = String(h).toLowerCase();
    if (/^[1-5]$/.test(h)) return parseInt(h, 10);
    for (var i = 0; i < this.cfg.formulas.length; i++) {
      var fh = this.cfg.formulas[i].handle || '';
      if (fh === h || fh.indexOf(h) === 0 || h.indexOf(fh) === 0) return this.cfg.formulas[i].index;
    }
    return null;
  };

  BuyBox.prototype.readUrl = function () {
    var params = new URLSearchParams(window.location.search);
    var f = this.formulaIndexFromHandle(params.get('formula'));
    if (f) this.preferred = f;
    var b = params.get('bundle') || params.get('tier');
    this.urlTier = null;
    if (b && this.cfg.useTiers) {
      var idx = this.tierIndexFromHandle(b);
      if (idx > -1) { this.state.tier = idx; this.urlTier = idx; }
    }
    if (f && this.cfg.useTiers) {
      var t = this.tier();
      if (t && this.requiredCount() === 0 && t.mode !== 'all') this.switchToChooser();
    }
  };

  BuyBox.prototype.tierIndexFromHandle = function (h) {
    h = String(h || '').toLowerCase();
    if (/^\d+$/.test(h)) return clamp(parseInt(h, 10) - 1, 0, this.cfg.tiers.length - 1);
    for (var i = 0; i < this.cfg.tiers.length; i++) {
      var th = (this.cfg.tiers[i].handle || '').toLowerCase();
      if (th === h || th.indexOf(h) === 0 || h.indexOf(th) === 0) return i;
    }
    return -1;
  };

  BuyBox.prototype.switchToChooser = function () {
    for (var i = 0; i < this.cfg.tiers.length; i++) {
      if (this.cfg.tiers[i].mode === 'choose' && this.cfg.tiers[i].available !== false) { this.state.tier = i; return; }
    }
  };

  BuyBox.prototype.requiredCount = function () {
    var t = this.tier();
    if (!t) return 0;
    if (t.refillChoice && this.state.single === 'refill') return 1;
    if (t.mode === 'choose') return clamp(parseInt(t.count, 10) || 1, 1, 5);
    return 0;
  };

  BuyBox.prototype.defaultPicks = function () {
    var base = this.cfg.formulas.map(function (f) { return f.index; });
    if (!base.length) base = [1, 2, 3, 4, 5];
    if (this.preferred) base = [this.preferred].concat(base.filter(function (x) { return x !== this.preferred; }, this));
    return base;
  };

  BuyBox.prototype.syncPicks = function () {
    var need = this.requiredCount();
    var picks = this.state.picks.slice(0, need);
    var defs = this.defaultPicks();
    if (this.preferred && need > 0 && picks.indexOf(this.preferred) === -1) {
      picks.unshift(this.preferred);
      picks = picks.slice(0, need);
    }
    var k = 0;
    while (picks.length < need && k < 20) {
      var cand = defs.filter(function (d) { return picks.indexOf(d) === -1; })[0];
      picks.push(cand != null ? cand : defs[k % defs.length]);
      k++;
    }
    this.state.picks = picks;
  };

  BuyBox.prototype.currentVariant = function () {
    var chosen = $$('[data-option]', this.root).map(function (fs) {
      var c = $('input:checked', fs);
      return c ? c.value : null;
    });
    var vs = this.cfg.variants;
    for (var i = 0; i < vs.length; i++) {
      var ok = vs[i].options.every(function (o, j) { return chosen[j] == null || o === chosen[j]; });
      if (ok) return vs[i];
    }
    return null;
  };

  BuyBox.prototype.picksLabel = function () {
    var counts = {};
    var order = [];
    var formulas = this.cfg.formulas;
    this.state.picks.forEach(function (i) {
      if (!counts[i]) { counts[i] = 0; order.push(i); }
      counts[i]++;
    });
    return order.map(function (i) {
      var f = formulas[i - 1] || { name: 'Formula ' + i };
      return counts[i] > 1 ? f.name + ' ×' + counts[i] : f.name;
    }).join(' + ');
  };

  /* "All 5 formulas", or "2 of each of the 5 formulas (10 tubs)" when a tier includes several tubs of every formula */
  BuyBox.prototype.allLabel = function (t) {
    var m = Math.max(1, parseInt(t && t.multiplier, 10) || 1);
    var n = this.cfg.formulas.length || 5;
    return m > 1 ? m + ' of each of the ' + n + ' formulas (' + (m * n) + ' tubs)' : 'All ' + n + ' formulas';
  };

  BuyBox.prototype.line = function () {
    var cfg = this.cfg;
    var s = this.state;
    var t = this.tier();
    if (cfg.useTiers && t) {
      if (t.refillChoice && s.single === 'refill') {
        var f = s.picks[0] || 1;
        var r = cfg.refill[f - 1] || {};
        var fm = cfg.formulas[f - 1] || {};
        return {
          id: r.id, price: r.price || 0, compareAt: r.compareAt || 0, available: !!(r.id && r.available),
          title: (cfg.refillTitle || 'Soap Ball Tub') + ' — ' + (fm.name || ''), image: fm.image || cfg.refillImage,
          properties: null, refill: true
        };
      }
      var props = null;
      if (t.mode === 'choose') props = { Formulas: this.picksLabel() };
      else if (t.mode === 'all') props = { Formulas: this.allLabel(t) };
      return { id: t.variantId, price: t.price || 0, compareAt: t.compareAt || 0, available: !!(t.variantId && t.available), title: t.title, image: t.image, properties: props };
    }
    var v = this.currentVariant();
    if (!v) return { id: null, price: 0, compareAt: 0, available: false, title: cfg.productTitle };
    var image = v.image;
    if (!image) {
      var vt = String(v.title || '').toLowerCase();
      cfg.formulas.forEach(function (fm) {
        if (!image && vt.indexOf(String(fm.name).toLowerCase().split(' ')[0]) === 0) image = fm.image;
      });
    }
    return { id: v.id, price: v.price, compareAt: v.compareAt || 0, available: v.available, title: cfg.productTitle + (cfg.variants.length > 1 ? ' — ' + v.title : ''), variant: v, image: image };
  };

  /* ---------------------------------------------------------------- events */
  BuyBox.prototype.bind = function () {
    var self = this;
    this.tierEls.forEach(function (el) {
      var input = $('[data-tier-input]', el);
      var idx = parseInt(el.getAttribute('data-tier'), 10);
      if (input) input.addEventListener('change', function () { if (input.checked) self.selectTier(idx); });
    });
    $$('[data-single]', this.root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.state.single = b.getAttribute('data-single');
        self.syncPicks();
        self.clearError();
        self.render();
        self.syncGallery();
      });
    });
    this.chips.forEach(function (chip) {
      var i = parseInt(chip.getAttribute('data-formula'), 10);
      var add = $('[data-formula-add]', chip);
      var rem = $('[data-formula-remove]', chip);
      if (add) add.addEventListener('click', function () { self.addPick(i, chip); });
      if (rem) rem.addEventListener('click', function () { self.removePick(i); });
    });
    $$('[data-option-input]', this.root).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var fs = inp.closest('[data-option]');
        var label = fs && $('[data-option-selected]', fs);
        if (label) label.textContent = inp.value;
        self.clearError();
        self.render();
        var v = self.currentVariant();
        self.syncGalleryVariant(v);
        if (v && self.cfg.context === 'main' && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
    $$('[data-qty-step]', this.root).forEach(function (b) {
      b.addEventListener('click', function () { self.setQty(self.state.qty + parseInt(b.getAttribute('data-qty-step'), 10)); });
    });
    if (this.qtyInput && this.qtyInput.type !== 'hidden') {
      this.qtyInput.addEventListener('change', function () { self.setQty(parseInt(self.qtyInput.value, 10)); });
    }
    if (this.form) {
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(false); });
    }
    if (this.buyNow) this.buyNow.addEventListener('click', function (e) { e.preventDefault(); self.submit(true); });

    document.addEventListener('sbp:select-tier', function (e) {
      if (!self.cfg.useTiers) return;
      var idx = self.tierIndexFromHandle(e.detail && e.detail.handle);
      if (idx > -1) self.selectTier(idx);
    });
    document.addEventListener('sbp:select-formula', function (e) {
      var i = e.detail && e.detail.index;
      if (!i) return;
      self.preferred = i;
      if (self.cfg.useTiers) {
        var t = self.tier();
        if (t && self.requiredCount() === 0 && t.mode !== 'all') { self.switchToChooser(); self.state.picks = []; }
        var need = self.requiredCount();
        if (need > 0) {
          var p = self.state.picks.slice();
          var at = p.indexOf(i);
          if (at > -1) p.splice(at, 1);
          p.unshift(i);
          self.state.picks = p.slice(0, need);
        }
        self.render();
        self.syncGallery();
        self.flashPicker();
      } else {
        var name = (self.cfg.formulas[i - 1] || {}).name;
        $$('[data-option-input]', self.root).forEach(function (inp) {
          if (name && inp.value.toLowerCase().indexOf(name.toLowerCase().split(' ')[0]) === 0) {
            inp.checked = true;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { self.busy = false; self.render(); } });
  };

  BuyBox.prototype.selectTier = function (i) {
    if (!this.cfg.tiers[i]) return;
    this.state.tier = i;
    if (!this.cfg.tiers[i].refillChoice) this.state.single = 'scrubber';
    this.syncPicks();
    this.clearError();
    this.render();
    this.syncGallery();
  };

  BuyBox.prototype.addPick = function (i, chip) {
    var need = this.requiredCount();
    if (!need) return;
    var p = this.state.picks;
    if (need === 1) this.state.picks = [i];
    else if (p.length < need) p.push(i);
    else { p.shift(); p.push(i); }
    this.clearError();
    this.render();
    if (this.state.single === 'refill') this.syncGallery();
    if (chip) {
      chip.classList.add('is-pop');
      setTimeout(function () { chip.classList.remove('is-pop'); }, 140);
    }
  };

  BuyBox.prototype.removePick = function (i) {
    var p = this.state.picks;
    var at = p.lastIndexOf(i);
    if (at > -1) p.splice(at, 1);
    this.render();
  };

  BuyBox.prototype.setQty = function (n) {
    n = clamp(parseInt(n, 10) || 1, 1, 99);
    this.state.qty = n;
    if (this.qtyInput) this.qtyInput.value = n;
    this.render();
  };

  BuyBox.prototype.flashPicker = function () {
    if (!this.picker || this.picker.hidden) return;
    this.picker.animate && this.picker.animate(
      [{ boxShadow: '0 0 0 0 rgba(242,165,65,0)' }, { boxShadow: '0 0 0 6px rgba(242,165,65,.55)' }, { boxShadow: '0 0 0 0 rgba(242,165,65,0)' }],
      { duration: 900, easing: 'ease-out' }
    );
  };

  /* ---------------------------------------------------------------- render */
  BuyBox.prototype.render = function () {
    var cfg = this.cfg;
    var s = this.state;
    var line = this.line();
    var total = line.price * s.qty;
    var self = this;

    /* tiers */
    this.tierEls.forEach(function (el, i) {
      var on = i === s.tier;
      el.classList.toggle('is-selected', on);
      var inp = $('[data-tier-input]', el);
      if (inp) inp.checked = on;
      var t = cfg.tiers[i];
      if (t && t.refillChoice) {
        var priceEl = $('[data-tier-price]', el);
        var p = on && s.single === 'refill' ? line.price : t.price;
        if (priceEl) priceEl.textContent = money(p);
        var was = $('.tier__was', el);
        if (was) was.hidden = on && s.single === 'refill';
      }
    });
    $$('[data-single]', this.root).forEach(function (b) {
      var on = b.getAttribute('data-single') === s.single;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    this.renderPicker();

    /* price */
    if (this.priceEl) this.priceEl.textContent = money(line.price);
    if (this.compareEl && this.saveEl) {
      if (line.compareAt > line.price) {
        var save = line.compareAt - line.price;
        this.compareEl.hidden = false;
        this.compareEl.textContent = money(line.compareAt);
        this.saveEl.hidden = false;
        this.saveEl.textContent = 'Save ' + money(save) + ' (' + Math.floor(save * 100 / line.compareAt) + '%)';
      } else {
        this.compareEl.hidden = true;
        this.saveEl.hidden = true;
      }
    }

    /* add to cart state */
    var need = this.requiredCount();
    var missing = need - s.picks.length;
    var label = cfg.atcLabel || strings.addToCart || 'Add to cart';
    var disabled = false;
    if (cfg.demo) { label = 'Preview only'; disabled = true; }
    else if (!line.id) { label = strings.unavailable || 'Unavailable'; disabled = true; }
    else if (!line.available) { label = strings.soldOut || 'Sold out'; disabled = true; }
    else if (missing > 0) { label = 'Pick ' + missing + ' more formula' + (missing > 1 ? 's' : ''); disabled = true; }
    if (this.atcLabel) this.atcLabel.textContent = label;
    if (this.atcPrice) this.atcPrice.textContent = disabled ? '' : money(total);
    if (this.atc) this.atc.disabled = disabled || this.busy;
    if (this.buyNow) this.buyNow.disabled = disabled || this.busy;
    this.disabled = disabled;
    this.disabledLabel = label;

    /* hidden inputs (also make the no-JS form post correct) */
    if (this.variantInput) this.variantInput.value = line.id || '';
    if (this.formulasInput) {
      var fv = line.properties && line.properties.Formulas;
      this.formulasInput.disabled = !fv;
      this.formulasInput.value = fv || '';
    }

    /* free-shipping note: only when the real threshold is met */
    if (this.freeEl) {
      var thr = cfg.freeShippingCents || 0;
      var free = thr > 0 && total >= thr;
      this.freeEl.hidden = !free;
      var span = $('span', this.freeEl);
      if (free && span) span.textContent = 'This order qualifies for free shipping';
    }

    if (this.bnpl) this.bnpl.update(total);
    this.renderSticky(line, total);
  };

  BuyBox.prototype.renderPicker = function () {
    if (!this.picker) return;
    var t = this.tier();
    var s = this.state;
    var need = this.requiredCount();
    var showAll = !!(t && t.mode === 'all' && !(t.refillChoice && s.single === 'refill'));
    var show = need > 0 || showAll;
    this.picker.hidden = !show;
    if (!show) return;
    var choose = $('[data-formula-choose]', this.picker);
    var all = $('[data-formula-all]', this.picker);
    if (choose) choose.hidden = need === 0;
    if (all) all.hidden = !showAll;
    var title = $('[data-formula-title]', this.picker);
    var count = $('[data-formula-count]', this.picker);
    if (showAll) {
      if (title) title.textContent = 'Your formulas';
      if (count) { count.textContent = ''; count.classList.remove('is-complete'); }
      var allText = $('[data-formula-all-text]', this.picker);
      if (allText) {
        var m = Math.max(1, parseInt(t.multiplier, 10) || 1);
        var n = this.cfg.formulas.length || 5;
        allText.innerHTML = m > 1
          ? '<strong>' + m + ' tubs of every formula</strong> — ' + (m * n) + ' tubs in total.'
          : 'All <strong>' + n + ' formulas</strong> included — find your dog\'s favourite.';
      }
    } else {
      if (title) title.textContent = need === 1 ? 'Pick your formula' : 'Pick your ' + need + ' formulas';
      if (count) {
        var done = s.picks.length === need;
        count.textContent = need > 1 ? s.picks.length + ' of ' + need + ' chosen' + (done ? ' ✓' : '') : '';
        count.classList.toggle('is-complete', done);
      }
    }
    this.chips.forEach(function (chip) {
      var i = parseInt(chip.getAttribute('data-formula'), 10);
      var n = s.picks.filter(function (p) { return p === i; }).length;
      chip.classList.toggle('is-selected', n > 0);
      var q = $('[data-formula-qty]', chip);
      if (q) { q.hidden = !(n > 0 && need > 1); q.textContent = '×' + n; }
      var minus = $('[data-formula-remove]', chip);
      if (minus) minus.hidden = !(n > 0 && need > 1);
      var add = $('[data-formula-add]', chip);
      if (add) add.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
    });
  };

  /* ---------------------------------------------------------------- gallery sync */
  BuyBox.prototype.syncGallery = function () {
    var g = this.gallery;
    if (!g || !g.slides.length) return;
    var t = this.tier();
    if (!t) return;
    var idx = -1;
    if (t.refillChoice && this.state.single === 'refill') {
      idx = g.find('data-tier-slide', 'refill');
    } else if (t.mediaId) {
      idx = g.find('data-media-id', t.mediaId);
    }
    if (idx === -1 && t.fallback) idx = g.find('data-tier-slide', t.fallback);
    if (idx > -1) g.go(idx);
  };
  BuyBox.prototype.syncGalleryVariant = function (v) {
    var g = this.gallery;
    if (!g || !g.slides.length || !v) return;
    var idx = v.mediaId ? g.find('data-media-id', v.mediaId) : -1;
    if (idx === -1) {
      var f = null;
      var vt = String(v.title || '').toLowerCase();
      this.cfg.formulas.forEach(function (fm) {
        if (f == null && vt.indexOf(String(fm.name).toLowerCase().split(' ')[0]) === 0) f = fm.index;
      });
      if (f) idx = g.find('data-formula-slide', f);
    }
    if (idx > -1) g.go(idx);
  };

  /* ---------------------------------------------------------------- submit */
  BuyBox.prototype.showError = function (msg) {
    if (!this.errorEl) { if (SBP.toast) SBP.toast(msg); return; }
    this.errorEl.textContent = msg;
    this.errorEl.hidden = false;
  };
  BuyBox.prototype.clearError = function () { if (this.errorEl) this.errorEl.hidden = true; };

  BuyBox.prototype.setBusy = function (busy, buyNow) {
    this.busy = busy;
    var btn = buyNow ? this.buyNow : this.atc;
    if (btn) btn.classList.toggle('is-loading', busy);
    if (this.stickyBtn) this.stickyBtn.classList.toggle('is-loading', busy && !buyNow);
    if (!busy) {
      if (this.atc) this.atc.classList.remove('is-loading');
      if (this.buyNow) this.buyNow.classList.remove('is-loading');
    }
    this.render();
  };

  BuyBox.prototype.submit = function (buyNow) {
    var self = this;
    if (this.busy) return; /* single-flight: a double tap can never add twice */
    var line = this.line();
    if (this.cfg.demo) { this.showError('Preview mode — connect your products to enable checkout.'); return; }
    if (this.disabled) {
      this.showError(this.disabledLabel || strings.cartError);
      if (this.requiredCount() > this.state.picks.length && this.picker) this.picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    this.clearError();
    var item = { id: Number(line.id), quantity: this.state.qty };
    if (line.properties) item.properties = line.properties;
    this.setBusy(true, buyNow);
    SBP.cart.add([item])
      .then(function () {
        if (buyNow) { window.location.href = SBP.checkoutUrl(); return; }
        if (SBP.cartType === 'page' || !document.getElementById('CartDrawer')) {
          window.location.href = SBP.routes.cart;
          return;
        }
        SBP.cart.open();
      })
      .catch(function (err) {
        self.showError(err && err.message ? err.message : (strings.cartError || 'Something went wrong'));
        if (self.errorEl) self.errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .then(function () { self.setBusy(false, buyNow); });
  };

  /* ---------------------------------------------------------------- sticky mobile ATC */
  BuyBox.prototype.initSticky = function () {
    var self = this;
    var bar = this.sticky;
    if (!bar) return;
    if (!this.cfg.showSticky || document.querySelector('.sticky-atc.is-owner')) { bar.remove(); this.sticky = null; return; }
    bar.classList.add('is-owner');
    document.body.appendChild(bar);
    this.stickyBtn = $('[data-sticky-add]', bar);
    this.stickyTitle = $('[data-sticky-title]', bar);
    this.stickyPrice = $('[data-sticky-price]', bar);
    this.stickyImg = $('[data-sticky-img]', bar);
    if (this.stickyBtn) this.stickyBtn.addEventListener('click', function () {
      if (self.disabled) { self.root.scrollIntoView({ behavior: 'smooth', block: 'start' }); self.submit(false); return; }
      self.submit(false);
    });
    var info = $('[data-sticky-scroll]', bar);
    if (info) info.addEventListener('click', function () {
      var target = $('[data-tiers]', self.root) || self.root;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var actions = $('.buybox__actions', this.root) || this.atc;
    var hero = document.querySelector('[data-hero]');
    var atcAbove = false;
    var atcVisible = false;
    var heroPassed = !hero;
    var dialogOpen = false;
    var mq = window.matchMedia('(max-width: 989px)');
    function update() {
      var show = mq.matches && !dialogOpen && (atcAbove || (heroPassed && !atcVisible && !!hero));
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      document.documentElement.style.setProperty('--sticky-atc-h', show ? bar.offsetHeight + 'px' : '0px');
    }
    if (!('IntersectionObserver' in window) || !actions) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        atcVisible = en.isIntersecting;
        atcAbove = !en.isIntersecting && en.boundingClientRect.bottom < 0;
      });
      update();
    }).observe(actions);
    if (hero) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { heroPassed = !en.isIntersecting && en.boundingClientRect.bottom < 0; });
        update();
      }).observe(hero);
    }
    document.addEventListener('sbp:dialog', function (e) { dialogOpen = !!(e.detail && e.detail.open); update(); });
    if (mq.addEventListener) mq.addEventListener('change', update);
  };

  BuyBox.prototype.renderSticky = function (line, total) {
    if (!this.sticky) return;
    var t = this.tier();
    var title = line.title || this.cfg.productTitle;
    if (t && t.mode === 'choose' && this.state.picks.length) title = t.title + ' · ' + this.picksLabel();
    if (this.stickyTitle) this.stickyTitle.textContent = title;
    if (this.stickyPrice) {
      var txt = money(total);
      if (line.compareAt > line.price) txt += '  (save ' + Math.floor((line.compareAt - line.price) * 100 / line.compareAt) + '%)';
      this.stickyPrice.textContent = txt;
    }
    if (this.stickyImg && line.image) this.stickyImg.src = line.image;
    if (this.stickyBtn) {
      this.stickyBtn.disabled = !!this.cfg.demo;
      this.stickyBtn.textContent = this.disabled && !this.cfg.demo ? 'Choose options' : (this.cfg.atcLabel || 'Add to cart');
    }
  };

  /* ================================================================ init */
  function init() {
    $$('[data-buybox]').forEach(function (root) {
      if (root._buybox) return;
      root._buybox = new BuyBox(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
